<app-side-nav *ngIf="user"></app-side-nav>
<router-outlet *ngIf="!user"></router-outlet>

